//format date to DD MMMM YYYY
export function useFormatDate(date: string) {
    return new Date(date).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    })
}